export const Moves=[
  "FORWARD",
  "CLOCKWISE",
  "ANTICLOCKWISE",
  "JUMP",
  "LOOP",
  "LIGHT"
]

export const Directions=[
  "RIGHT","DOWN","LEFT","UP"
]
export const Rotations={"RIGHT":0,"DOWN":90, "LEFT":180, "UP":270}

export const secondTutorialLevel = 5;

export const NEW_DATA_EVENT = "NEW_DATA_EVENT";

export const PAUSE_TIMER_EVENT = "PAUSE_TIMER_EVENT";
export const RESUME_TIMER_EVENT = "RESUME_TIMER_EVENT";